// 组件对象，大写
import crudArray from './crudArray.vue'
export default crudArray
